<template>
  <div class="ov-card">
    <div class="ov-card__head">
      <div class="ov-card__title">
        Droits &amp; permissions
        <span class="ov-count">{{ functionnalities ? functionnalities.length : 0 }}</span>
      </div>
    </div>
    <div class="ov-card__body">
      <div v-if="functionnalities && functionnalities.length > 0" class="uf-list">
        <span v-for="(f, i) in functionnalities" :key="i" class="uf-chip">{{ f.libelle }}</span>
      </div>
      <div v-else class="ov-empty">Aucune permission assignée</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "userFunctionnalities.vue",
  props: ["functionnalities"],
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/admin/ui";

.uf-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.uf-chip {
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: $ov-green-dark;
  background: rgba(21, 158, 114, 0.08);
  border: 1px solid rgba(21, 158, 114, 0.18);
}
</style>
